<div class="form-item-content">
  <div class="input-wrapper">
    <input
      type="text"
      placeholder="дд.мм.гггг"
      mask="00.00.0000"
      [specialCharacters]="['.']"
      [dropSpecialCharacters]="false"
      [formControl]="dateField">
    <input type="hidden" disabled [matDatepicker]="picker" [value]="selectedDate" (dateInput)="setDate($event?.target.value)">
    <mat-datepicker-toggle matSuffix disableRipple [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker touchUi disabled="false"></mat-datepicker>
    <span *ngIf="errMsg" class="error-msg">{{ errMsg }}</span>
  </div>
  <button class="form-btn" (click)="getDate()">Расчёт</button>
</div>

<span  class="matrix-string">{{ matrixString }}/ЧС{{ data.destinyNumb}}/Т{{ data?.temp || '-' }}/Ц{{ data?.goal || '-' }}/С{{ data?.fam || '-' }}/П{{ data?.habits || '-' }}/Б{{ data?.byt || '-' }}</span>

  <div id="main-matrix" class="matrix-table">
    <div class="destiny-cell bb br">
      <span>ЧС</span>
      <span *ngIf="matrixString">{{ data?.destinyNumb || '' }}</span>
    </div>
    <div class="date-cell bb br">
      <span>{{ status === 'show' ? dateField.value : '' }}</span>
      <span></span>
    </div>
    <div class="bb">
      <span>Темперамент</span>
      <span>{{ data?.temp || '-' }}</span>
    </div>
    <div class="bb br">
      <span>Характер</span>
      <span>{{ returnString(data?.character, '1') || '-' }}</span>
    </div>
    <div class="bb br">
      <span>Здоровье</span>
      <span>{{ returnString(data?.health, '4') || '-' }}</span>
    </div>
    <div class="bb br">
      <span>Удача</span>
      <span>{{ returnString(data?.luck, '7') || '-' }}</span>
    </div>
    <div class="bb">
      <span>Цель</span>
      <span>{{ data?.goal || '-' }}</span>
    </div>
    <div class="bb br">
      <span>Энергия</span>
      <span>{{ returnString(data?.energy, '2') || '-' }}</span>
    </div>
    <div class="bb br">
      <span>Логика</span>
      <span>{{ returnString(data?.logic, '5') || '-' }}</span>
    </div>
    <div class="bb br">
      <span>Долг</span>
      <span>{{ returnString(data?.dolg, '8') || '-' }}</span>
    </div>
    <div class="bb">
      <span>Семья</span>
      <span>{{ data?.fam || '-' }}</span>
    </div>
    <div class="br">
      <span>Интерес</span>
      <span>{{ returnString(data?.interest, '3') || '-' }}</span>
    </div>
    <div class="bb br">
      <span>Труд</span>
      <span>{{ returnString(data?.work, '6') || '-' }}</span>
    </div>
    <div class="br">
      <span>Память</span>
      <span>{{ returnString(data?.memory, '9') || '-' }}</span>
    </div>
    <div>
      <span>Привычки</span>
      <span>{{ data?.habits || '-' }}</span>
    </div>
    <div class="last-cell">
      <span>Быт</span>
      <span>{{ data?.byt || '-' }}</span>
    </div>
  </div>
